export const StripeSetup = (props) => {
	const auth = props.auth;
	const playerData = props.playerData;

	const handleStripeSetup = (e) => {
		e.preventDefault();
		fetch(`/api/stripe/setup`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${auth.user.access_token}`,
			},
		})
			.then((resp) => {
				if (!resp.ok) {
					throw new Error("Could not finish stripe setup");
				}
				return resp.json();
			})
			.then((r) => {
				window.open(r.url);
			})
			.catch((error) => console.log(error));
	};

	const getStripeLoginLink = (e) => {
		e.preventDefault();
		fetch(`/api/stripe/login`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${auth.user.access_token}`,
			},
		})
			.then((resp) => {
				if (!resp.ok) {
					throw new Error("Could not get Stripe Login Link");
				}
				return resp.json();
			})
			.then((r) => {
				window.open(r.url);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	if (playerData.stripe_id === null) {
		return (
			<div className="flex underline text-blue-600">
				<a href="#" onClick={handleStripeSetup}>
					Connect your Stripe Account
				</a>
			</div>
		);
	}
	return (
		<div className="flex underline text-blue-600">
			<a href="#" onClick={getStripeLoginLink}>
				Access your Stripe Dashboard
			</a>
		</div>
	);
};
